import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';
import { DeviceDetectorService } from 'ngx-device-detector';
import { KeywordsAndConstants } from '../../core/keywords-and-constants';
import { AccessControlService } from './access-control.service';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import {
  BehaviorSubject,
  Observable,
  throwError,
  tap,
  switchMap,
  of,
  catchError,
  filter,
  take,
  finalize,
} from 'rxjs';
import { Apis } from '../../core/apis';
import { environment } from '../../environments/environment';

var myItem = uuidv4();

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  deviceInfo: any;
  deviceName: String = '';
  uniqueIdentifierId: any;
  deviceUserAgent: any;
  platform: string = '';
  backUpToken: string = '';
  backUpRefreshToken: string = '';

  refreshing = false;
  refreshSubject: BehaviorSubject<string | null> = new BehaviorSubject<
    string | null
  >(null);

  constructor(
    public constants: KeywordsAndConstants,
    private router: Router,
    private deviceService: DeviceDetectorService,
    private _controlService: AccessControlService,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      if (
        localStorage.getItem('uniqueIdentifierId') == '' ||
        localStorage.getItem('uniqueIdentifierId') == null ||
        localStorage.getItem('uniqueIdentifierId') == undefined
      ) {
        localStorage.setItem('uniqueIdentifierId', myItem);
      }

      window.addEventListener('beforeunload', () => {
        if (localStorage.getItem('refreshOnProgress')) {
          localStorage.setItem('refreshOnProgress', 'false');
        }
      });
    }
  }

  getToken() {
    try {
      // if (
      //   localStorage.getItem(this.constants.LocalStorageToken) &&
      //   this.backUpToken != ''
      // ) {
      //   if (
      //     this.backUpToken !=
      //     localStorage.getItem(this.constants.LocalStorageToken)
      //   ) {
      //     console.log('sending the backup token');
      //     return this.backUpToken;
      //   }
      // }
      if (isPlatformBrowser(this.platformId)) {
        const token = localStorage.getItem(this.constants.LocalStorageToken);
        if (!token) {
          return undefined;
        }
        const authToken = JSON.parse(token);
        return authToken;
      }
    } catch (error) {
      return error;
    }
  }

  getRefreshToken() {
    try {
      // if (
      //   localStorage.getItem(this.constants.LocalStorageToken) &&
      //   this.backUpRefreshToken != ''
      // ) {
      //   console.log(
      //     this.backUpRefreshToken,
      //     localStorage.getItem(this.constants.LocalStorageRefreshToken)
      //   );
      //   if (
      //     this.backUpRefreshToken !=
      //     localStorage.getItem(this.constants.LocalStorageRefreshToken)
      //   ) {
      //     console.log('sending the backup refresh token');
      //     return this.backUpRefreshToken;
      //   }
      // }
      if (isPlatformBrowser(this.platformId)) {
        const refreshtoken = localStorage.getItem(
          this.constants.LocalStorageRefreshToken
        );
        if (!refreshtoken) {
          return undefined;
        }
        const authrefreshToken = JSON.parse(refreshtoken);
        return authrefreshToken;
      }
    } catch (error) {
      return error;
    }
  }

  deviceInformation() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    if (isPlatformBrowser(this.platformId)) {
      this.uniqueIdentifierId = localStorage.getItem('uniqueIdentifierId');
    }
    this.deviceUserAgent = this.deviceInfo.userAgent;
    switch (this.deviceInfo.deviceType) {
      case 'desktop': {
        if (this.deviceInfo.os == 'Windows') {
          this.deviceInfo.browser = 'WINDOWS_DESKTOP';
          this.platform = 'WINDOWS_DESKTOP';
        } else {
          this.deviceInfo.browser = 'MAC';
          this.platform = 'MAC';
        }
        break;
      }
      case 'mobile': {
        if (this.deviceInfo.os == 'Android') {
          this.deviceInfo.browser = 'ANDROID';
          this.platform = 'ANDROID';
        } else {
          this.deviceInfo.browser = 'IOS';
          this.platform = 'IOS';
        }
        break;
      }
      default: {
      }
    }
  }

  /** Check if JWT expired */
  isTokenExpired(token: string | null): boolean {
    if (!token) return true;
    try {
      const expTimeStamp = Number(
        new JwtHelperService().decodeToken(token).exp
      );
      const currentTimeStamp = Number(
        new Date().getTime().toString().slice(0, 10)
      );
      const res = Number(expTimeStamp) - Number(currentTimeStamp);
      return res < 5;
    } catch (e) {
      return true;
    }
  }

  refreshToken(): Observable<string> {
    if (!this.getRefreshToken()) {
      return throwError(() => 'No refresh token available');
    }
    const isRefreshing = localStorage.getItem('refreshOnProgress');

    if (!this.refreshing && (!isRefreshing || isRefreshing === 'false')) {
      this.refreshing = true;
      localStorage.setItem('refreshOnProgress', 'true');
      this.refreshSubject.next(null);
      return this.http
        .get(Apis.refreshToken, {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': environment.allowed_origin,
            Authorization: `Bearer ${this.getRefreshToken()}`,
          }),
        })
        .pipe(
          tap((refreshTokenResponse: any) => {
            if (refreshTokenResponse) {
              if (isPlatformBrowser(this.platformId)) {
                localStorage.setItem(
                  this.constants.LocalStorageToken,
                  JSON.stringify(refreshTokenResponse.token)
                );
                localStorage.setItem(
                  this.constants.LocalStorageRefreshToken,
                  JSON.stringify(refreshTokenResponse.refreshToken)
                );
                this.backUpToken = JSON.stringify(refreshTokenResponse.token);
                this.backUpRefreshToken = JSON.stringify(
                  refreshTokenResponse.refreshToken
                );

                const helper = new JwtHelperService();
                const decodedToken = helper.decodeToken(
                  refreshTokenResponse.token
                );
                localStorage.setItem(
                  this.constants.isLoginType,
                  decodedToken.type
                );
              }

              this.refreshSubject.next(refreshTokenResponse.token);
            }
          }),
          switchMap((refreshTokenResponse: any) =>
            of(refreshTokenResponse.token)
          ),
          catchError((err) => {
            this.refreshSubject.error(err);
            return throwError(() => err);
          }),
          finalize(() => {
            this.refreshing = false;
            localStorage.setItem('refreshOnProgress', 'false');
            this.refreshSubject = new BehaviorSubject<string | null>(null);
          })
        );
    } else {
      return this.refreshSubject.pipe(
        filter((token): token is string => token != null),
        take(1)
      );
    }
  }

  clearTokens(): void {
    localStorage.removeItem(this.constants.LocalStorageToken);
    localStorage.removeItem(this.constants.LocalStorageRefreshToken);
  }

  logout() {
    let isMasterUserLoggedIn =
      localStorage.getItem(this.constants.isLoginType) == 'MASTER_USER';
    let isUserLoggedIn =
      localStorage.getItem(this.constants.isLoginType) == 'USER';

    let isSubUserLoggedIn =
      localStorage.getItem(this.constants.isLoginType) == 'ADMIN_USER';
    let existingUniqueId = localStorage.getItem('uniqueIdentifierId');
    this.backUpToken = '';
    this.backUpRefreshToken = '';
    this._controlService.CategoryMethod = [];
    this._controlService.byCategoryMethod = null;
    localStorage.clear();
    localStorage.setItem('uniqueIdentifierId', existingUniqueId!!);
    if (isMasterUserLoggedIn) {
      this.router.navigate(['/master-user/login']);
      1;
    } else if (isUserLoggedIn) {
      this.router.navigate(['/user/login']);
    } else if (isSubUserLoggedIn) {
      this.router.navigate(['/admin/login']);
    } else {
      this.router.navigate(['']);
    }
  }
}
